
import Divider from '@mui/material/Divider';

export default function ToolbarVerticalDivider() {
  return (
    <Divider orientation="vertical" flexItem variant="middle" sx={{ marginLeft: 1, marginRight: 1 }} />
  );
}